var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 13.3334V9.16671M10 13.3334V6.66671M13.3333 13.3334V11.6667M15 3.33337H5C4.55798 3.33337 4.13405 3.50897 3.82149 3.82153C3.50893 4.13409 3.33334 4.55801 3.33334 5.00004V15C3.33334 15.4421 3.50893 15.866 3.82149 16.1786C4.13405 16.4911 4.55798 16.6667 5 16.6667H15C15.442 16.6667 15.866 16.4911 16.1785 16.1786C16.4911 15.866 16.6667 15.4421 16.6667 15V5.00004C16.6667 4.55801 16.4911 4.13409 16.1785 3.82153C15.866 3.50897 15.442 3.33337 15 3.33337Z",
    stroke: "#9EA0F0",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsActive);
export default __webpack_public_path__ + "static/media/analytics-active.e2b60e94f9a0dd310aca5c249879ae18.svg";
export { ForwardRef as ReactComponent };